import { Component, Input, ViewChild } from '@angular/core';
import { AuftragExportTemplate } from '../select-auftragstyp/select-auftragstyp.component';
import { FormsModule, NgForm } from '@angular/forms';
import { ExportKriterienDetailEntryMeta } from '../../../../../core/batch-auftrag-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../../../../core/extension/exceptions/cap-alert-level.enum';
import { CapiWizardComponent } from '../../../shared/capi-wizard/capi-wizard.component';
import { CapFormColumnsDirective } from '../../../../../shared/form-control/form-columns.directive';
import { SelectGrundstueckbeschreibungComponent } from '../select-grundstueckbeschreibung/select-grundstueckbeschreibung.component';
import { SelectEigentumComponent } from '../select-eigentum/select-eigentum.component';
import { SelectStammpersonComponent } from '../select-stammperson/select-stammperson.component';
import { CdkStepperPrevious } from '@angular/cdk/stepper';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'cap-select-auftragsexportkriterien',
  templateUrl: './select-auftragsexportkriterien.component.html',
  imports: [
    FormsModule,
    CapFormColumnsDirective,
    SelectGrundstueckbeschreibungComponent,
    SelectEigentumComponent,
    SelectStammpersonComponent,
    CdkStepperPrevious,
    RouterLink,
    TranslatePipe
  ]
})
export class SelectAuftragsexportkriterienComponent {
  @ViewChild('form', { static: true })
  form: NgForm;

  @Input()
  wizard: CapiWizardComponent;

  @Input()
  readonly: boolean;

  exportKriterien: ExportKriterienDetailEntryMeta;
  veraenderbar: boolean;

  constructor(
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {}

  _template: AuftragExportTemplate;

  get template(): AuftragExportTemplate {
    return this._template;
  }

  @Input()
  set template(template: AuftragExportTemplate) {
    if (!template) {
      return;
    }
    this._template = template;
    this.veraenderbar = template.model.exportkriterienVeraenderbar;
    this.applyNewTemplate();
  }

  public validateAndGoToNextStep() {
    if (!this.veraenderbar || this.form.valid) {
      this.wizard.next();
    } else {
      const params = { fehlerMeldung: this.translate.instant('EingabeMussMindestensEineGrundstueckbeschreibungHaben') };
      this.capAlertService.warning(this.translate.instant('ValidierungsFehler', params), CapAlertLevel.CONTENT_HEADER);
    }
  }

  private applyNewTemplate() {
    this.form.reset();
    if (this.template.model.exportkriterienVeraenderbar) {
      this.form.form.enable();
    } else {
      this.form.form.disable();
    }
    this.exportKriterien = this.template.model.exportKriterien;
  }
}
